/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/**
 * Determines if anonymous checkout should be enabled based on configuration values only.
 * @param allowAnonymousCheckout - The AllowAnonymousCheckout value from cart configuration.
 * @param showGuestCheckoutButton - The showGuestCheckoutButton value from module config.
 */
export function isAnonymousCheckoutEnabled(
    allowAnonymousCheckout: boolean | undefined,
    showGuestCheckoutButton: boolean | undefined
): boolean {
    // Enable anonymous checkout if:
    // 1. allowAnonymousCheckout is true
    // 2. OR allowAnonymousCheckout is false/undefined AND showGuestCheckoutButton is true
    const isCartAnonymousEnabled = allowAnonymousCheckout ?? false;
    return isCartAnonymousEnabled || (!isCartAnonymousEnabled && showGuestCheckoutButton === true);
}
